<template> 
<div class="pt425" id="pt425">
    <!--パンくず-->
    <breadcrumb :navListCustom="[{title:'マイページ', routerName: pt425Init.myPage, param: {pageNo: '81'}}, {title:$t('pt425.labels.title'), routerName: '', param: {}}]"></breadcrumb>
    <div class="searchCondition">
        <!--マイページタイトル-->
        <h2>{{$t('common.labels.titleHeaderOrder')}}</h2>
        <div class="pt425Main">
            <!--請求一覧タイトル-->
            <div class="itemTitle">
                <h3>{{$t('pt425.labels.title')}}</h3>
            </div>
            <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt425'"/>
            <div id="warming">
                <p class="caution mb32"></p>
            </div>
                <div v-if="pageFeedData.totalRecord > 0">
                    <div class="">
                        <!-- 請求締日 -->
                        <div class="pt425SearchSeikyuuSimebiDiv">
                            <div class="pt425SearchSeikyuuSimebiDivLine">
                                <label id="searchSeikyuuYmd_lbl" class="pt425SearchSeikyuuYmd" v-if="pt425Init.siteFlg == 1" >{{$t('pt425.labels.searchSeikyuuSimebi')}}</label>
                                <label id="searchSeikyuuYmd_lbl" class="pt425SearchSeikyuuYmd" v-else >{{$t('pt425.labels.searchSeikyuubi')}}</label>
                                <div class="pt425ColP0">
                                    <div class="pt425FormRowFormInline">
                                        <div class="pt425col2">
                                            <date-pickers
                                                v-model="reqModel.searchSeikyuuSimebiFrom"
                                                ref="searchSeikyuuSimebiFrom"
                                                :not-after="reqModel.searchSeikyuuSimebiTo"
                                                :elementId="'searchSeikyuuSimebiFrom'"
                                                :input-name="'searchSeikyuuSimebiFrom'"
                                                :type="'date'"
                                                :format="'YYYY/MM/DD'"
                                                :placeholder="$t('pt425.labels.datePickerFormat')"
                                                input-class="datepicker ll-skin-santiago form-control form-control-sm col"
                                            />
                                        </div>
                                        <div class="pt425FromTo">{{$t('common.labels.fromTo')}}</div>
                                        <div class="pt425col2">
                                            <date-pickers
                                                v-model="reqModel.searchSeikyuuSimebiTo"
                                                :not-before="reqModel.searchSeikyuuYmdFrom"
                                                :elementId="'searchSeikyuuSimebiTo'"
                                                :input-name="'searchSeikyuuSimebiTo'"
                                                :type="'date'"
                                                :format="'YYYY/MM/DD'"
                                                :placeholder="$t('pt425.labels.datePickerFormat')"
                                                input-class="datepicker ll-skin-santiago form-control form-control-sm col"
                                            />
                                        </div>
                                        <div>
                                            <!-- 検索 -->
                                            <a class="btnSel" @click="search()">{{$t('pt425.labels.search')}}</a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <br>
                </div>
                <!-- 検索結果に一致する注文がない場合 -->
                <div v-if="noResult" class="pt425ErrorMessageDiv" >
                    <span class="pt425ErrorMessage">
                        <!-- 検索条件に一致する注文がありませんでした。 -->
                        {{$t('pt425.labels.messgNoResult')}}
                    </span>
                </div>
                <!-- ページャー表示 -->
                <div class="mb64 pt15">
                    <page-feed v-if="isDisplay"
                        :isDisplay="isPagingDisplay"
                        :isDisplaySort="false"
                        :pageFeedData="pageFeedData"
                        :orderByType="ptOrderByType"
                        :dispPageSizeList="dispPageSizeList"
                        @search="changeSearch"
                        >
                        <template slot="TableRender">
                            <div id="check_lbl" class="mb-4">
                                <!-- 選択印刷 -->
                                <button
                                    class="btnDownload"
                                    @click="doPrintSelected()"
                                    :disabled="selectedList.length == 0"
                                >{{$t('pt425.buttons.selectPrint')}}</button>
                                &nbsp;
                                <!-- 一括印刷 -->
                                <button
                                    class="btnDownload"
                                    @click="doIkatuPrintConfirm()"
                                >{{$t('pt425.buttons.IkatuPrint')}}</button>
                            </div>
                            <!-- BtoBの場合 -->
                            <table v-if="pt425Init.siteFlg == 1" class="pt425BillList" id="cart-history" >
                                <thead>
                                    <th scope="col" class="pt425ListCheckBox">
                                        <input type="checkbox" v-model="selectAll" @change="selectAllItems">
                                    </th>
                                    <!-- No. -->
                                    <th scope="col" class="pt425ListNO">{{$t('pt425.labels.no')}}</th>
                                    <!-- 請求日 -->
                                    <th scope="col" class="pt425ListSearchSeikyuuYmd">{{$t('pt425.labels.searchSeikyuuYmd')}}</th>
                                    <!-- 請求番号 -->
                                    <th scope="col" class="pt425ListSearchSeikyuuKanriCd">{{$t('pt425.labels.searchSeikyuuKanriCd')}}</th>
                                    <!-- 請求金額 -->
                                    <th scope="col" class="pt425ListSeikyuTaxIn">{{$t('pt425.labels.seikyuTaxIn')}}</th>
                                    <!-- 消込状態 -->
                                    <th scope="col" class="pt425ListNyukinStatus">{{$t('pt425.labels.nyukinStatus')}}</th>
                                    <!-- 印刷状況 -->
                                    <th scope="col" class="pt425ListPrintStatus">{{$t('pt425.labels.printStatus')}}</th>
                                    <!-- 領収書出力 -->
                                    <th v-if="pt425Init.ryousyuusyoDispFlg == 1" scope="col" class="pt425ListRyousyuusyo">{{$t('pt425.labels.ryousyuusyo')}}</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(orders, index) in pt425Init.list" :key="index">
                                        <td class="pt425ListCheckBox">
                                            <input v-if="orders.CANCEL_FLG != 1" type="checkbox" v-model="orders.checked" @change="updateSelectedList">
                                        </td>
                                        <!-- No. -->
                                        <td class="pt425ListNO" scope="row" aria-label="No.">
                                            {{pageFeedData.fromRecord+index}}
                                        </td>
                                        <!-- 請求日 -->
                                        <td class="pt425ListSearchSeikyuuYmd" :aria-label="$t('pt425.labels.searchSeikyuuYmd')">
                                            <span>{{orders.SEIKYUU_S_YMD}}</span>
                                        </td>
                                        <!-- 請求番号 -->
                                        <td class="pt425ListSearchSeikyuuKanriCd" :aria-label="$t('pt425.labels.searchSeikyuuKanriCd')">
                                            <span>{{orders.SEIKYUU_KANRI_CD}}</span>
                                        </td>
                                        <!-- 請求金額 -->
                                        <td class="pt425ListSeikyuTaxIn" :aria-label="$t('pt425.labels.seikyuTaxIn')">
                                            <input-number v-model="orders.SEIKYU_TAX_IN" :readonly="true" :suffix ="'円'" />
                                        </td>
                                        <!-- 消込状態 -->
                                        <td class="pt425ListNyukinStatus" :aria-label="$t('pt425.labels.nyukinStatus')">
                                            <span>{{orders.KESIKOMI}}</span>
                                        </td>
                                        <!-- 印刷状況 -->
                                        <td class="pt425ListPrintStatus" :aria-label="$t('pt425.labels.printStatus')">
                                            <span>{{orders.PRINT_STATUS}}</span>
                                        </td>
                                        <!-- 領収書出力 -->
                                        <td v-if="pt425Init.ryousyuusyoDispFlg == 1" class="pt425ListRyousyuusyo" :aria-label="$t('pt425.labels.ryousyuusyo')">
                                            <input v-if="orders.KESSAI_CD == '6' && orders.RYOUSYUUSYO_FLG == 1 && orders.CANCEL_FLG != 1 && checkKesikomi(orders)" 
                                                @click="doDownloadRyousyuuPdf(orders.SEIKYUU_KANRI_CD,'241')" :value="$t('pt425.labels.ryousyuusyo')" type="button">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <!-- BtoCの場合 -->
                            <table v-else class="pt425BillList" id="cart-history">
                                <thead>
                                    <th scope="col" class="pt425ListCheckBox">
                                        <input type="checkbox" v-model="selectAll" @change="selectAllItems">
                                    </th>
                                    <!-- No. -->
                                    <th scope="col" class="pt425ListNO">{{$t('pt425.labels.no')}}</th>
                                    <!-- 請求日 -->
                                    <th scope="col" class="pt425ListSearchSeikyuuYmd">{{$t('pt425.labels.searchSeikyuuYmd')}}</th>
                                    <!-- 請求番号 -->
                                    <th scope="col" class="pt425ListSearchSeikyuuKanriCd">{{$t('pt425.labels.searchSeikyuuKanriCd')}}</th>
                                    <!-- お客様番号 -->
                                    <th scope="col" class="pt425ListSearchKokyakuCd">{{$t('pt425.labels.searchKokyakuCd')}}</th>
                                    <!-- 顧客名 -->
                                    <th scope="col" class="pt425ListSearchTokuisakiNm">{{$t('pt425.labels.searchKokyakuNm')}}</th>
                                    <!-- 請求金額 -->
                                    <th scope="col" class="pt425ListSeikyuTaxIn">{{$t('pt425.labels.seikyuTaxIn')}}</th>
                                    <!-- 消込状態 -->
                                    <th scope="col" class="pt425ListNyukinStatus">{{$t('pt425.labels.nyukinStatus')}}</th>
                                    <!-- 印刷状況 -->
                                    <th scope="col" class="pt425ListPrintStatus">{{$t('pt425.labels.printStatus')}}</th>
                                    <!-- 領収書出力 -->
                                    <th v-if="pt425Init.ryousyuusyoDispFlg == 1" scope="col" class="pt425ListRyousyuusyo">{{$t('pt425.labels.ryousyuusyo')}}</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(orders, index) in pt425Init.list" :key="index">
                                        <td class="pt425ListCheckBox">
                                            <input v-if="orders.CANCEL_FLG != 1" type="checkbox" v-model="orders.checked" @change="updateSelectedList">
                                        </td>
                                        <!-- No. -->
                                        <td class="pt425ListNO" scope="row" aria-label="No.">
                                            {{pageFeedData.fromRecord+index}}
                                        </td>
                                        <!-- 請求日 -->
                                        <td class="pt425ListSearchSeikyuuYmd" :aria-label="$t('pt425.labels.searchSeikyuuYmd')">
                                            <span>{{orders.SEIKYUU_S_YMD}}</span>
                                        </td>
                                        <!-- 請求番号 -->
                                        <td class="pt425ListSearchSeikyuuKanriCd" :aria-label="$t('pt425.labels.searchSeikyuuKanriCd')">
                                            <span>{{orders.SEIKYUU_KANRI_CD}}</span>
                                        </td>
                                        <!-- お客様番号 -->
                                        <td class="pt425ListSearchKokyakuCd" :aria-label="$t('pt425.labels.searchKokyakuCd')">
                                            <span>{{orders.KOKYAKU_CD}}</span>
                                        </td>
                                        <!-- 顧客名 -->
                                        <td class="pt425ListSearchTokuisakiNm" :aria-label="$t('pt425.labels.searchKokyakuNm')">
                                            <span>{{orders.KOKYAKU_NM}}</span>
                                        </td>
                                        <!-- 請求金額 -->
                                        <td class="pt425ListSeikyuTaxIn" :aria-label="$t('pt425.labels.seikyuTaxIn')">
                                            <input-number v-model="orders.SEIKYU_TAX_IN" :readonly="true" :suffix ="'円'" />
                                        </td>
                                        <!-- 消込状態 -->
                                        <td class="pt425ListNyukinStatus" :aria-label="$t('pt425.labels.nyukinStatus')">
                                            <span>{{orders.KESIKOMI}}</span>
                                        </td>
                                        <!-- 印刷状況 -->
                                        <td class="pt425ListPrintStatus" :aria-label="$t('pt425.labels.printStatus')">
                                            <span>{{orders.PRINT_STATUS}}</span>
                                        </td>
                                        <!-- 領収書出力 -->
                                        <td v-if="pt425Init.ryousyuusyoDispFlg == 1" class="pt425ListRyousyuusyo" :aria-label="$t('pt425.labels.ryousyuusyo')">
                                            <input v-if="orders.KESSAI_CD == '6' && orders.RYOUSYUUSYO_FLG == 1 && orders.CANCEL_FLG != 1 && checkKesikomi(orders)" 
                                                @click="doDownloadRyousyuuPdf(orders.SEIKYUU_KANRI_CD,'241')" :value="$t('pt425.labels.ryousyuusyo')" type="button">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                    </page-feed>
                    
                    <!--戻るボタン-->
                    <div id="btn_roll3" v-if="pt425Init.backButtonFlg == 1">
                        <a class="btnBack" @click="backUrl()">{{$t('common.buttons.return')}}</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- modal alert confirm -->
        <alert-confirm
        v-if="isModalShow"
        :msgConfirm="msgConfirm"
        :okAction="doAction"
        @closedModal="isModalShow = false"
        :isButtonCancel="isButtonCancel"
        />
    </div>
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import InputCheck from 'components/InputCheck';
import InputNumber from 'components/InputNumber';
import Message from 'components/MessageEcSite';
import AlertConfirm from "components/AlertConfirm";
import DatePickers from "components/DatePicker";
import DataTable from "components/Datatable";
import EventBus from "assets/js/eventBus";
import PageFeed from '../commonParts/PageFeed';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import Loading from 'vue-loading-overlay';
export default {
    /* 
    * Name of component
    */
    name: "PT425MemberOrderHisParts",
    /*
    * Declare props
    */
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        },
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /*
    * Declare components
    */
    components:{
            DataTable,
            InputCheck,
            InputNumber,
            Message,
            AlertConfirm,
            DatePickers,
            PageFeed,
            Loading,
            Breadcrumb
        },
    data() {
        return {
            isDisplay: false,
            noResult: false,
            rowIndex: null,
            isPagingDisplay:true,
            isLoading: false,
            isModalShow: false,
            siteFlg : null,
            isTuisekiLinkShow: false,
            selectAll: false,
            reqModel:{
                totalRecord: null,
                fromRecord: null,
                toRecord: null,
                rirekiKbn:'0',
                searchKbn:'1',
                pageSize: this.ptPageSize != undefined ? this.ptPageSize : 15,
                pageNo: this.ptPageNo != undefined ? this.ptPageNo : 1
            },
            pt425Init: {
                orderNoDispFlg: 0,
                amountDispFlg: 0,
                transCoDispFlg: 0,
                toiNoDispFlg: 0,
                payDispFlg: 0,
                storeDispFlg: 0,
                tantoDispFlg: 0,
                backButtonFlg: 0
            },
            pageFeedData: {
                totalRecord: 50,
                fromRecord: 0,
                toRecord: 10,
                pageSize: 10,
                pageNo: 1
            },
            requestTable: {},
            dispPageSizeList:[
                {value: 5,text: "5行"},
                {value: 15,text: "15行"},
                {value: 30,text: "30行"},
                {value: 45,text: "45行"},
                {value: 50,text: "50行"},
                {value: 100,text: "100行"}
            ],
            SiteConstants: SiteConstants,
            iSearch:false,
            msgConfirm:'',
            action: "",
            powerInfo: {},
            selectedList: [],
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],
            jptuisekiLink: null,
            site: "",
            tnkDspKbn: null,

            pagination: {
            sortBy: 'name'
            },
            selected: [],
            headers: [
                {
                    text: 'Dessert (100g serving)',
                    align: 'left',
                    value: 'name'
                },
                { text: 'Calories', value: 'calories' },
                { text: 'Fat (g)', value: 'fat' },
                { text: 'Carbs (g)', value: 'carbs' },
                { text: 'Protein (g)', value: 'protein' },
                { text: 'Iron (%)', value: 'iron' }
            ],
            desserts: [
                {
                name: 'Frozen Yogurt',
                calories: 159,
                fat: 6.0,
                carbs: 24,
                protein: 4.0,
                iron: '1%'
                },
                {
                name: 'Ice cream sandwich',
                calories: 237,
                fat: 9.0,
                carbs: 37,
                protein: 4.3,
                iron: '1%'
                },
                {
                name: 'Eclair',
                calories: 262,
                fat: 16.0,
                carbs: 23,
                protein: 6.0,
                iron: '7%'
                }
            ]
        }
    },
    /*
    * 初期表示
    */
    mounted() {
        // Call API doInit
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt425Init = _this.ptInitData;
        }else{
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT425 + _this.$UrlConstants.DO_INIT, _this.reqModel).then(function(response) {
                _this.pt425Init = response.data;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
        // 未ログインの場合
        if(_this.pt425Init.status == 'NG'){
            // ログイン画面へ遷移
            const parameter = _this.generateLinkParams(18, _this.pt425Init.loginPage, {returnFlg: 1, fromMyPage: 1});
            _this.$router.push(parameter);
        }else {
            // 検索
            _this.reqModel = Object.assign({}, _this.reqModel, _this.pt425Init.reqModel);
            _this.search();
        }

        // selected DataTable list
        EventBus.$on('selected', function(selectedList) {
            _this.selectedList = selectedList;
        });

    },
    /*
    * メソッド
    */
    methods: {
        /*
        * 検索処理
        */
        search: function() {
            var _this = this;
            // Clear msg validate
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr,'pt425');
            _this.$emit("event-loading", true);
            
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT425 + _this.$UrlConstants.DO_SEARCH, _this.reqModel).then(function(response) {
                _this.pt425Init = response.data;
                if (response.data.list != null && response.data.list.length > 0) {
                    _this.pageFeedData.totalRecord = response.data.totalRecord;
                    _this.reqModel.totalRecord = response.data.totalRecord;
                    _this.pageFeedData.fromRecord = response.data.fromRecord;
                    _this.pageFeedData.toRecord = response.data.toRecord;
                    _this.pageFeedData.pageSize = response.data.pageSize;
                    _this.pageFeedData.pageNo = response.data.pageNo;
                    _this.tnkDspKbn = _this.pt425Init.list[0].TNK_DSP_KBN;


                    _this.isDisplay = true; 
                    _this.isPagingDisplay = true;
                    _this.noResult = false;
                    // 追跡リンク表示フラグ
                    if(_this.pt425Init.tuisekiLinkFlg == 1){
                        _this.isTuisekiLinkShow = true;
                    }else{
                        _this.isTuisekiLinkShow = false;
                    }
                }else{
                    _this.isDisplay = false;
                    _this.noResult = true;
                    _this.reqModel.totalRecord = 0;
                }
                _this.selectAll = false;
                _this.selectedList = [];
                _this.$emit("event-loading", false);
                EventBus.$emit("event-dataTable", _this.requestTable);
            }).catch(function(error) {
                _this.isDisplay = false;
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error,'pt425');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * 領収書ダウンロード pdf
        */
        doDownloadRyousyuuPdf: function(seikyuuKanriCd,printYoutoKbn) {
            var _this = this;
            _this.isLoading = true;

            _this.printData = {};
            _this.printData.action="241";
            _this.printData.printList =[];
            _this.printData.printList.push(seikyuuKanriCd);
            //var fullPath = window.location.href;
            //_this.printData.wfrBasePath = fullPath.substring(0,fullPath.lastIndexOf("/"));

            let appPath = process.env.VUE_APP_PUBLIC_PATH;
            if(appPath.endsWith('/')) {
                appPath = appPath.slice(0, -1);
            }
            if(appPath.startsWith('/')) {
                appPath = appPath.slice(1);
            }
            _this.printData.wfrBasePath = window.location.protocol + "//" + window.location.host + "/" +appPath;

            _this.printData.pdfFlg = "0";
            _this.printData.reqModel = _this.reqModel;
            
            _this.$emit("event-loading", true);
            axios({url: _this.$UrlConstants.ECSITE + _this.$UrlConstants.PT425 + _this.$UrlConstants.DO_PRINT, method: "POST", responseType: "blob", data: _this.printData}).then(function(response) {
                var fileName = "";
                var disposition = response.headers["content-disposition"];
                if (disposition && disposition.indexOf("attachment") !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    fileName = matches[1].replace(/['"]/g, "");
                }
                }
                if (/*@cc_on!@*/ false || !!document.documentMode) {
                window.navigator.msSaveBlob(new Blob([response.data]), fileName);
                } else {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                }
                _this.search();
                _this.$emit("event-loading", false);
            }).catch(async function(error) {
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            if (error.request.responseType === "blob") {
                                let responseObj = await error.response.data.text();
                                error.response.data = JSON.parse(responseObj);
                            }
                            var resultValid = common.excuteValidationEcSite(error, 'pt425');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }
                    }
                }
                _this.$emit("event-loading", false);
            });
        },
        /*
        * 戻るボタン押下処理
        */
        backUrl: function() {
            var _this = this;
            // マイメニュー画面へ遷移
            const parameter = _this.generateLinkParams(81,_this.pt425Init.myPage);
            _this.$router.push(parameter);
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {},additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        },
        pt425search: function(skbn) {
            var _this = this;
            _this.reqModel.searchKbn = skbn;
            _this.reqModel.pageNo = 1;
            _this.changeSearch(_this.reqModel.orderByType,_this.reqModel.pageSize,_this.reqModel.pageNo);
        },

        //Methods for pageFeed
        changeSearch: function(sortNo, pageSize, pageNo) {
            this.reqModel.pageSize = pageSize;
            this.reqModel.pageNo = pageNo;
            this.reqModel.orderByType = sortNo;
            var queryString = this.getQueryString(pageSize, 'ptPageSize');
            let appPath = process.env.VUE_APP_PUBLIC_PATH;
            if(appPath.endsWith('/')) {
                appPath = appPath.slice(0, -1);
            }
            location.href = appPath + this.$route.path + '?' + queryString;
        },
        changePageSize: function(pageSize) {
            this.reqModel.pageSize = pageSize;
            var queryString = this.getQueryString(pageSize, 'ptPageSize');
            location.href = process.env.VUE_APP_PUBLIC_PATH + this.$route.path + '?' + queryString;
        },
        changePageNo: function(pageNo) {
            this.reqModel.pageNo = pageNo;
            var queryString = this.getQueryString(pageNo, 'ptPageNo');
            location.href = process.env.VUE_APP_PUBLIC_PATH + this.$route.path + '?' + queryString;
        },
        getQueryString: function(val, type){
            var query = this.$route.query;
            query.ptPageNo = this.reqModel.pageNo;
            query.ptPageSize = this.reqModel.pageSize;
            query.sKbn = this.reqModel.searchKbn;
            query.rKbn = this.reqModel.rirekiKbn;
            query.searchSeikyuuSimebiFrom = this.reqModel.searchSeikyuuSimebiFrom;
            query.searchSeikyuuSimebiTo = this.reqModel.searchSeikyuuSimebiTo;

            if(this.reqModel.orderByType != undefined) {
                query.ptOrderByType = this.reqModel.orderByType;
            }
            
            query[type] = val;

            var queryString = "";
            var index= 0;
            for(var propertyName in query) {
                if(index == 0){
                    queryString += propertyName + '=' + query[propertyName];
                } else{
                    queryString += '&' + propertyName + '=' + query[propertyName];
                }
                index++;
            }
            return queryString;
        },

        selectAllItems() {
            for (let item of this.pt425Init.list) {
                item.checked = this.selectAll;
            }
            if (this.selectAll) {
                this.selectedList = this.pt425Init.list.filter(orders => orders.checked);
            } else {
                this.selectedList = [];
            }
        },
        updateSelectedList () {
            this.selectedList = this.pt425Init.list.filter(orders => orders.checked);
            if (this.selectedList.length == 0) {
                this.selectAll = false;
            }
            if (this.selectedList.length == this.pt425Init.list.length) {
                this.selectAll = true;
            }
        },

        /*
        * 選択印刷
        */
        doPrintSelected: function() {
            var _this = this;
            _this.printList = [];
            var i,n = 0;

            for (i = 0, n = _this.selectedList.length; i < n; i++) {
                _this.printList.push(_this.selectedList[i].SEIKYUU_KANRI_CD);
            }

            if (_this.printList.length < 1) {
                alert(_this.$i18n.t("common.messages.selectedConfirm"));
                return;
            }
            _this.action = "PrintSeikyuusyo";
            _this.confirmPrint();
        },

        /*
        * 確認 confirm print
        */
        confirmPrint: function() {
        var _this = this;
        _this.size = "sm";
        _this.isButtonCancel = true;
        _this.msgConfirm = _this.$i18n.t("pt425.messages.printConfirm");
        _this.isModalShow = true;
        },

        /*
        * 確認：一括印刷
        */
        doIkatuPrintConfirm: function() {
            var _this = this;
            _this.size = "sm";
            _this.isButtonCancel = true;
            _this.msgConfirm =_this.$i18n.t("pt425.messages.printConfirm");
            _this.action="IkatuPrint";
            _this.isModalShow = true;
       },

       /*
        *  execute update or delete or insert
        */
        doAction: function(){
            var _this = this;
            // Hide alert confirm
            _this.isModalShow = false;

            if(_this.action ==""){
                return;
            }
            if(_this.action == "PrintSeikyuusyo"){
                _this.doActionPrint();
            }
            if(_this.action == "IkatuPrint"){
                _this.doActionPrint();
            }
        },
        /*
       *  execute print(Preview Or DownloadPdf)
       */
        doActionPrint: function() {
            var _this = this;
            // Hide alert confirm
            _this.isModalShow = false;

            _this.printData = {};
            _this.printData.printList = _this.printList;
            
            _this.printData.pdfFlg = "0";
            _this.printData.action = _this.action;
            if( _this.printData.action == "IkatuPrint"){
                _this.printData.printList =[];
            }
            _this.printData.reqModel = _this.reqModel;
            common.clearMessage([]);
            _this.isLoading = true;
            //【PDF出力は行う】 
            _this.doDownloadPdf();
        },

        /*
        * ダウンロード pdf
        */
        doDownloadPdf: function() {
            var _this = this;
            _this.isLoading = true;

            _this.printData = {};
            _this.printData.printList = _this.printList;
            _this.printData.pdfFlg = "1";
            _this.printData.action = _this.action;
            if(_this.printData.action == "IkatuPrint"){
                _this.printData.printList =[];
            }
            _this.printData.reqModel = _this.reqModel;
            //var fullPath = window.location.href;
            //_this.printData.wfrBasePath = fullPath.substring(0,fullPath.lastIndexOf("/"));
            let appPath = process.env.VUE_APP_PUBLIC_PATH;
            if(appPath.endsWith('/')) {
                appPath = appPath.slice(0, -1);
            }
            if(appPath.startsWith('/')) {
                appPath = appPath.slice(1);
            }
            _this.printData.wfrBasePath = window.location.protocol + "//" + window.location.host + "/" +appPath;

            _this.$emit("event-loading", true);
            axios({url: _this.$UrlConstants.ECSITE + _this.$UrlConstants.PT425 + _this.$UrlConstants.DO_PRINT, method: "POST", responseType: "blob", data: _this.printData}).then(function(response) {
                var fileName = "";
                var disposition = response.headers["content-disposition"];
                if (disposition && disposition.indexOf("attachment") !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    fileName = matches[1].replace(/['"]/g, "");
                }
                }
                if (/*@cc_on!@*/ false || !!document.documentMode) {
                window.navigator.msSaveBlob(new Blob([response.data]), fileName);
                } else {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                }
                _this.search();
                _this.$emit("event-loading", false);
            }).catch(async function(error) {
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            if (error.request.responseType === "blob") {
                                let responseObj = await error.response.data.text();
                                error.response.data = JSON.parse(responseObj);
                            }
                            var resultValid = common.excuteValidationEcSite(error, 'pt425');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }
                    }
                }
                _this.$emit("event-loading", false);
            });
        },

        /* 
        * Function 
        * 追跡サイトへのリンク押下時処理
        */
        selectTuisekiLink: function(){
            //追跡サイトリンク
            window.open(this.pt425Init.tuisekiLinkUrl);
        },
        /* 
        * Function 
        * 追跡サイトへのリンク押下時処理
        */
        selectTuisekiLinkUrl: function(_transCoKbn,_okuriNo){
            if ('JP' == _transCoKbn) {
                var _jpLinkUrl = this.pt425Init.jptuisekiLink.replace('[1]',_okuriNo);
                window.open(_jpLinkUrl);
            } else if ('SG' == _transCoKbn) {
                var _sgLinkUrl = this.pt425Init.sgtuisekiLink.replace('[1]',_okuriNo);
                window.open(_sgLinkUrl);
            } else if ('YA' == _transCoKbn) {
                var _yaLinkUrl = this.pt425Init.yatuisekiLink.replace('[1]',_okuriNo);
                window.open(_yaLinkUrl);
            }
        },

        /* 
        * Function 
        * 消込チェック
        */
        checkKesikomi: function(orders){
            if(orders.CHK_FLG != '0'){
                return true;
            } else if (orders.RECEIPT_KIN_SUMI > 0) {
                return true;
            }
            return false;
        },
    },

    /*
    * Excute code after an instance is created
    */
    created: function() {
        var _this = this;
        this.queryData = this.$route.query;
        if(this.queryData != null){
            if(this.queryData.sKbn != null){
                this.reqModel.searchKbn = this.queryData.sKbn;
            }
            if(this.queryData.rKbn != null){
                this.reqModel.rirekiKbn = this.queryData.rKbn;
            }
            if(this.queryData.ptPageNo != null){
                this.reqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.reqModel.pageSize = this.queryData.ptPageSize;
            }
            if(this.queryData.searchSeikyuuSimebiFrom != null){
                this.reqModel.searchSeikyuuSimebiFrom = this.queryData.searchSeikyuuSimebiFrom;
            }
            if(this.queryData.searchSeikyuuSimebiTo != null){
                this.reqModel.searchSeikyuuSimebiTo = this.queryData.searchSeikyuuSimebiTo;
            }
        }
        //Get param from router when contructor this.  
        var data = _this.$route.params;
        if (data.requestBack!=null){
            _this.reqModel = Object.assign({}, _this.reqModel, data.requestBack);
            _this.iSearch=true;
        }
    }
}
</script>
<style scoped>

a.btnSel {
    background-color: #95af6c;
    border-radius: 4px;
    border: none;
    color: #fff;
    font-size: 1.1em;
    letter-spacing: 1px;
    padding: 8px 16px;
    color: #fff !important;
}
div.pt425ErrorMessageDiv{
    margin-bottom: 16px;
    font-size: 1.3em;
}

div.pt425SearchSeikyuuSimebiDiv {
    padding-left: .5rem!important;
    padding-right: .5rem!important;
    margin-bottom: .25rem!important;
    -ms-flex: 0 0 100%;
    -webkit-box-flex: 0;
    flex: 0 0 100%;
    max-width: 100%;
}

div.pt425SearchSeikyuuSimebiDivLine {
    -ms-flex-align: start!important;
    -webkit-box-align: start!important;
    align-items: flex-start!important;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -5px;
    margin-left: -5px;
    border: 0;
    font-style: normal;
    /* font-size: 12px; */
    margin: 0;
    padding: 0;
    vertical-align: baseline;
}

label.pt425SearchSeikyuuYmd{
    padding-top: calc(.25rem + 1px);
    padding-bottom: calc(.25rem + 1px);
    font-size: .875rem;
    line-height: 1.5;
    margin-bottom: 0;
    display: inline-block;
    color:#dc3545!important
}

div.pt425ColP0{
    padding: 0!important;
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    -webkit-box-flex: 1;
    flex-grow: 1;
    max-width: 100%;
}
div.pt425col2{
    padding-right: 5px;
    padding-left: 5px;
    -ms-flex: 0 0 16.666667%;
    -webkit-box-flex: 0;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
}

div.pt425FormRowFormInline {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-flow: row wrap;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-flow: row wrap;
    -ms-flex-align: center;
    -webkit-box-align: center;
    align-items: center;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -5px;
    margin-left: -5px;
}

table th.pt425ListCheckBox{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table td.pt425ListCheckBox{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table th.pt425ListNO{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table td.pt425ListNO{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table th.pt425ListSearchSeikyuuYmd{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table td.pt425ListSearchSeikyuuYmd{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table th.pt425ListSearchSeikyuuKanriCd{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table td.pt425ListSearchSeikyuuKanriCd{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table th.pt425ListSearchKokyakuCd{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table td.pt425ListSearchKokyakuCd{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table th.pt425ListSearchTokuisakiNm{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table td.pt425ListSearchTokuisakiNm{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table th.pt425ListSeikyuTaxIn{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table td.pt425ListSeikyuTaxIn{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table th.pt425ListNyukinStatus{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table td.pt425ListNyukinStatus{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table th.pt425ListPrintStatus{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table td.pt425ListPrintStatus{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table th.pt425ListBushoNm{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}

table td.pt425ListBushoNm{
    font-size: 15px;
    text-align: center;
    border-right: 1px solid #eee;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.8;
    padding: 10px 20px;
}


</style>
